// extracted by mini-css-extract-plugin
export default {"mCard":"MD-z","image":"ND-z","imageNoBackground":"OD-z","imageHasCategory":"PD-z","fullWidth":"QD-z"};